<div class="calculator__inner pb-90">
  <div class="calculator__left">
    <div class="calculator__left-top">
      <div class="calculator__left-title">Отправитель</div>
    </div>
    <div class="chooseState">
      <el-form-item prop="applicationCargoPickup.isCargoPickup" class="calculator__extraServise-item">
        <el-switch v-model="dataForm.applicationCargoPickup.isCargoPickup" active-text="Забор груза" @change="cargoPickupChange();" :disabled="cargoPickupSwitchFrom()"/>
      </el-form-item>
      <el-form-item prop="applicationCargoPickup.pickupDate" class="calculator__form-item zabor5stepHiddeble" v-if="dataForm.applicationCargoPickup.isCargoPickup">
        <el-date-picker style="width: auto" v-model="dataForm.applicationCargoPickup.pickupDate" type="date"
          placeholder="Выберите дату" format="DD/MM/YYYY" :disabled-date="datePickerOptions"
          :disabled="!dataForm.applicationCargoPickup.isCargoPickup" @change="changeDate('pickupDate')"
          class="datepicker-here" />
      </el-form-item>
    </div>
    <div class="block__notice">
      Стоимость забора на режимных объектах и/или объектах с пропускным режимом, до нестандартных адресов (поселков, отдаленных улиц) может измениться. 
    </div>

    

    <el-form-item label="Адрес забора груза" prop="applicationCargoPickup.addressCargoPickup" v-if="dataForm.applicationCargoPickup.isCargoPickup">
      <el-autocomplete
        class="calculator__form-item"
        v-model="dataForm.applicationCargoPickup.addressCargoPickup"
        :disabled="!dataForm.applicationCargoPickup.isCargoPickup" 
        :fetch-suggestions="getFromAddressSearch"
        @input="getFromAddress"
        @select="dataForm.applicationCargoPickup.addressSelected = true"
        clearable
        placeholder="Улица, дом, кв./оф." 
        :trigger-on-focus="false"
      />
    </el-form-item>
    <div class="total-weight--error total-weight--error_prefix_icon no-shift" v-show="checkCityRoadFrom()">
      <div class="warning-icon">i</div>
      Внимание: выдача/прием груза в  {{dataForm.sender.cityFrom}} осуществляется на трассе. В населенный пункт авто не заезжает!
    </div>

    <el-form-item class="calculator__extraServise-item">
      <el-switch v-model="dataForm.applicationCargoPickup.adressDetailRequired" active-text="Добавьте комментарий к адресу, если не нашли его в поисковике" v-if="dataForm.applicationCargoPickup.isCargoPickup"/>
    </el-form-item>

    <el-form-item prop="applicationCargoPickup.addressCargoPickupNotice" class="calculator__form-item calculator__form-item-sm" v-if="dataForm.applicationCargoPickup.adressDetailRequired && dataForm.applicationCargoPickup.isCargoPickup">
      <el-input
        v-model="dataForm.applicationCargoPickup.addressCargoPickupNotice"
        placeholder="Улица, дом, кв./оф." 
      />
      <!-- <div class="block__note" v-if="dataForm.applicationCargoPickup.adressDetailRequired && dataForm.applicationCargoPickup.isCargoPickup">
        Стоимость забора/доставки до нестандартных адресов (поселков, отдаленных улиц) может измениться.
      </div> -->
    </el-form-item>


    


    <el-form-item label="Доступное время забора" prop="applicationCargoPickupTime.cargoTimePickup" class="form-group d-block" v-if="dataForm.applicationCargoPickup.isCargoPickup">

      <!-- Выбор времени забора -->
      <el-form-item class="cargo-time-pickup__outer">
        <el-form-item 
          class="calculator__input calulator__input_type_time-pickup">
          <el-select 
            v-model="dataForm.applicationCargoPickupTime.cargoTimePickup" 
            placeholder="Выберите время забора" 
            value-key='intervalTitle'>
            <el-option 
              v-for="(timePickup, index) in dataForm.applicationCargoPickupTime.cargoTimePickupRange.value" 
              :key="index" 
              :label="timePickup.intervalTitle" 
              :value="timePickup"
            />
          </el-select>
        </el-form-item>
      </el-form-item>
      <!-- /Выбор времени забора -->

      <!-- <el-form-item prop="applicationCargoPickup.cargoStartTimePickup" class="calculator__form-items"
        label="Время забора от">
        <el-time-select v-model="dataForm.applicationCargoPickup.cargoStartTimePickup" placeholder="С"
          :start="time.cargoPickup.with.start" :step="time.step" :end="time.cargoPickup.with.end"
          :disabled="!dataForm.applicationCargoPickup.isCargoPickup"
          @change="changeStartTime('cargoStartTimePickup')" />
      </el-form-item>
      <el-form-item prop="applicationCargoPickup.cargoEndTimePickup" class="calculator__form-items"
        label="Время забора до">
        <el-time-select v-model="dataForm.applicationCargoPickup.cargoEndTimePickup" placeholder="ДО"
          :start="time.cargoPickup.before.start" :step="time.step" :end="time.cargoPickup.before.end"
          class="hidden_el-input__prefix hidden_el-input__suffix"
          :disabled="!dataForm.applicationCargoPickup.isCargoPickup" @change="changeEndTime('cargoEndTimePickup')" />
      </el-form-item> -->

      <div class="total-weight--error" v-if="checkDayToDay(dataForm.applicationCargoPickup.pickupDate) && checkCity() && !dataForm.isSpecialClient">
        День в день
        <span v-if="!checkHour()">после 12:00, больше 30кг не принимается</span>
        <span v-else>до 15:00, принимаются заявки до 30кг</span>

      </div>
    </el-form-item>
    <el-form-item class="form-group launch-line" v-if="dataForm.applicationCargoPickup.isCargoPickup">
      <div class="decore-radio m-0">Время обеденного перерыва</div>
      <div class="d-flex">
        <el-form-item prop="applicationCargoPickupTime.startTimeLunchBreak">
          <el-time-select v-model="dataForm.applicationCargoPickup.startTimeLunchBreak"
            :max-time="dataForm.applicationCargoPickup.endTimeLunchBreak" placeholder=" " start="09:00"
            :step="time.step" end="23:00" class="calc-inputsTime__wrapper suffix_visible_show"
            :disabled="!dataForm.applicationCargoPickup.isCargoPickup" />
        </el-form-item>
        -
        <el-form-item prop="applicationCargoPickupTime.endTimeLunchBreak">
          <el-time-select v-model="dataForm.applicationCargoPickup.endTimeLunchBreak"
            :min-time="dataForm.applicationCargoPickup.startTimeLunchBreak" placeholder=" " start="10:00"
            :step="time.step" :end="time.cargoDelivery.before.end"
            class="calc-inputsTime__wrapper suffix_visible_show"
            :disabled="!dataForm.applicationCargoPickup.isCargoPickup" @change="chengeTimeLunch('endTimeLunchBreak')" />
        </el-form-item>
      </div>

    </el-form-item>

    <div class="uslugi">
      <div class="uslugi__area uslugi__area_type_switch-with-input uslugi__area_type_multi-input">
        <el-form-item>
          <el-form-item prop="services.powerOfAttorney" class="calculator__toggle">
            <div class="calculator__toggle-title">Доверенность<span class="question" data-text=""></span></div>
            <el-switch v-model="dataForm.services.powerOfAttorney"
                @change="dataForm.services.typePowerOfAttorney = dataForm.services.powerOfAttorney ? dataForm.services.typePowerOfAttorney : ''" />
          </el-form-item>
        </el-form-item>
    
        <el-form-item class="uslugi__inputs margin-bottom--40" v-if="dataForm.services.powerOfAttorney">
          <el-form-item class="uslugi__input uslugi__input_add_label" :disabled="!dataForm.services.powerOfAttorney">
            <div class="uslugi__label">Выберите вариант:</div>
            <el-form-item class="calculator__toggle-input"
            prop="services.typePowerOfAttorney" :required="dataForm.services.powerOfAttorney">
              <el-select  v-model="dataForm.services.typePowerOfAttorney" :disabled="!dataForm.services.powerOfAttorney"
                class="uslugi__input uslugi__input_add_label">
                <el-option v-for="option in optionsTypePowerOfAttorney" :key="option.value" :label="option.label"
                :value="option.value" />
              </el-select>
            </el-form-item>
          </el-form-item>
        </el-form-item>    
      </div>
    </div>
    
    <el-form-item>
      <el-form-item label="Комментарий" prop="applicationCargoPickup.comment">
        <el-input v-model="dataForm.applicationCargoPickup.comment" type="textarea" />
      </el-form-item>
    </el-form-item>
  </div>
  <div class="calculator__center-line"></div>
  <div class="calculator__right second-right">
    <div class="calculator__right-top">
      <div class="calculator__right-title">Получатель</div>
    </div>
    <div class="chooseState">
      <el-form-item prop="applicationCargoPickup.deliveryToTheAddress">
        <el-switch v-model="dataForm.applicationCargoPickup.deliveryToTheAddress" active-text="Доставка до адреса"
          :disabled="cargoPickupSwitchTo() || dataForm.consignee?.cityTo.includes('(Москва)')"/>
      </el-form-item>
    </div>

    <div class="block__notice">
      Стоимость доставки на режимные объекты и/или объекты с пропускным режимом, до нестандартных адресов (поселков, отдаленных улиц) может измениться.
    </div>

    <template v-if="dataForm.applicationCargoPickup.deliveryToTheAddress">
      <el-form-item v-if="!dataForm.consignee?.cityTo.includes('(Москва)')" label="Адрес получателя" prop="applicationCargoPickup.addressConsignee">
        <el-autocomplete
          class="calculator__form-item"
          v-model="dataForm.applicationCargoPickup.addressConsignee" 
          :disabled="!dataForm.applicationCargoPickup.deliveryToTheAddress"
          :fetch-suggestions="getToAddressSearch"
          @select="dataForm.applicationCargoPickup.addressSelectedTo = true"
          @input="getToAddress"
          clearable
          placeholder="Улица, дом, кв./оф." 
          :trigger-on-focus="false"
        />
      </el-form-item>
      <div class="total-weight--error total-weight--error_prefix_icon no-shift" v-show="checkCityRoadTo()">
        <div class="warning-icon">i</div>
        Внимание: выдача/прием груза в  {{dataForm.consignee.cityTo}} осуществляется на трассе. В населенный пункт авто не заезжает!
      </div>

      <el-form-item v-if="!dataForm.consignee?.cityTo.includes('(Москва)')" class="calculator__extraServise-item">
        <el-switch v-model="dataForm.applicationCargoPickup.adressDetailRequiredTo" active-text="Добавьте комментарий к адресу, если не нашли его в поисковике" v-if="dataForm.applicationCargoPickup.deliveryToTheAddress"/>
      </el-form-item>
  
      <el-form-item prop="applicationCargoPickup.addressCargoPickupNoticeTo" class="calculator__form-item calculator__form-item-sm" v-if="dataForm.applicationCargoPickup.adressDetailRequiredTo && dataForm.applicationCargoPickup.deliveryToTheAddress">
        <el-input
          v-if="!dataForm.consignee?.cityTo.includes('(Москва)')"
          :disabled="dataForm.consignee?.cityTo.includes('(Москва)')"
          v-model="dataForm.applicationCargoPickup.addressCargoPickupNoticeTo"
          placeholder="Улица, дом, кв./оф." 
        />
        <!-- <div class="block__note" v-if="dataForm.applicationCargoPickup.adressDetailRequiredTo && dataForm.applicationCargoPickup.deliveryToTheAddress">
          Стоимость забора/доставки до нестандартных адресов (поселков, отдаленных улиц) может измениться.
        </div> -->
      </el-form-item>

      <!-- <el-form-item
            label="Дата доставки"
            prop="applicationCargoPickup.deliveryDate"
          >
            <el-date-picker
              style="width: auto"
              v-model="dataForm.applicationCargoPickup.deliveryDate"
              type="date"
              placeholder="Выберите дату"
              firstDayWeek="2"
              format="DD/MM/YYYY"
              value-format="YYYY-MM-DD"
              :disabled-date="datePickerOptionsDelivery"
              @change="changeDate('deliveryDate')"
            />
          </el-form-item> -->


          <el-form-item v-if="!dataForm.consignee?.cityTo.includes('(Москва)')" label="Доступное время доставки" prop="applicationCargoPickupTime.cargoTimePickupDelivery" class="form-group d-block">
       
        <!-- Выбор времени забора -->
        <el-form-item class="cargo-time-pickup__outer">
          <el-form-item 
            class="calculator__input calulator__input_type_time-pickup">
            <el-select 
              v-model="dataForm.applicationCargoPickupTime.cargoTimePickupDelivery" 
              placeholder="Выберите время доставки" 
              value-key='intervalTitle'>
              <el-option 
                v-for="(timePickup, index) in dataForm.applicationCargoPickupTime.cargoTimePickupRangeDelivery.value" 
                :key="index" 
                :label="timePickup.intervalTitle" 
                :value="timePickup"
              />
            </el-select>
          </el-form-item>
        </el-form-item>
        <!-- /Выбор времени забора -->

      </el-form-item>
      <el-form-item v-if="!dataForm.consignee?.cityTo.includes('(Москва)')" class="form-group launch-line">
        <div class="decore-radio m-0">Время обеденного перерыва</div>
        <div class="d-flex">
          <el-form-item prop="applicationCargoPickup.startTimeLunchBreakDelivery">
            <el-time-select v-model="dataForm.applicationCargoPickup.startTimeLunchBreakDelivery"
              :max-time="dataForm.applicationCargoPickup.endTimeLunchBreakDelivery" placeholder=" " start="09:00"
              :step="time.step" end="23:00" class="calc-inputsTime__wrapper suffix_visible_show" />
          </el-form-item>
          -
          <el-form-item prop="applicationCargoPickup.endTimeLunchBreakDelivery">
            <el-time-select v-model="dataForm.applicationCargoPickup.endTimeLunchBreakDelivery"
              :min-time="dataForm.applicationCargoPickup.startTimeLunchBreakDelivery" placeholder=" " start="10:00"
              :step="time.step" :end="time.cargoDelivery.before.end"
              class="calc-inputsTime__wrapper suffix_visible_show" />
          </el-form-item>
        </div>
      </el-form-item>
    </template>
  </div>
  <div class="calculateArrow">
    <div class="step-counter">5/{{ dataForm.totalSteps }}</div>
    <div class="arrows-steps-prev" @click="$emit('click-button-back')"></div>
    <div class="arrows-steps-next"
    @click="$emit('click-button-next', [...getArrayOfRules(dataForm.applicationCargoPickup, 'applicationCargoPickup'), ...getArrayOfRules(dataForm.applicationCargoPickupTime, 'applicationCargoPickupTime'), ...getArrayOfRules({typePowerOfAttorney: dataForm.services.typePowerOfAttorney}, 'services')]);">
    </div>
  </div>
</div>

